import React from 'react';
import Dropzone from 'react-dropzone';
import { Api } from '../api';
import Poller from '../helpers/Poller';
import EpubValidatorResults from './EpubValidatorResults';
import CheckLog from './CheckLog';
import Log from './Log';
import {
  Alert,
  Button, ButtonGroup,
  Container, Row, Col,
  Label, Input, InputGroup,
  Modal, ModalHeader, ModalBody, ModalFooter,
} from 'reactstrap';

export default class EpubValidator extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = this.initialState();
  }

  errorMessages() {
    return {
      basic: 'The ePub ' + this.props.check + ' could not check the file. Contact support@scribenet.com if the problem persists.',
      badFile: 'The selected file is not an ePub.',
    };
  }

  initialState() {
    return {
      loading: false,
      finished: false,
      errMessage: this.errorMessages().basic,
      error: false,
      name: null,
      checks: null,
    };
  }

  reset = () => {
    this.setState(this.initialState());
  }

  onDrop = (files) => {
    this.reset();
    const file = files[0];
    if (file.name.slice(-5) === '.epub') {
      this.uploadFile(file);
    } else {
      this.setError(this.errorMessages().badFile);
    }
  }

  setError = (message = this.errorMessages().basic) => {
    this.setState({ finished: true, error: true, errMessage: message });
  }

  uploadFile = (file) => {
    this.toggleLoading();
    const apiAddress = this.props.check == 'accessibility checker' ? 'accessibility_check' : 'validate';
    Api.upload('/wfdw/epub/' + apiAddress, this.formData(file)).then((json) => {
      this.setState({ name: file.name });
      const assetId = json.asset_id;
      this.pollStatus(assetId);
    }).catch((err) => {
      this.setError();
    });
  }

  pollStatus = (id) => {
    const poll = new Poller(
      () => Api.get(`/api/assets/status/${id}`),

      json => json.status === 'ok',

      () => {
        this.retrieveFileChecks(id).then(() => {
          this.toggleLoading();
          this.setState({ finished: true });
        });
      },

      2000,
    );

    poll.poll();
  }

  retrieveFileChecks = id => Api.get(`/api/assets/checks/${id}`).then((json) => {
    this.setState({ checks: json });
  })

  formData = (file) => {
    const formData = new FormData();
    formData.append('asset', file, file.name);
    return formData;
  }

  toggleLoading = () => {
    this.setState({ loading: !this.state.loading });
  }

  checksReport = () => (<EpubValidatorResults
    key="epubValResult"
    text={`${this.props.check == 'accessibility checker' ? 'Accessibility' : 'Validation'} Report for ${this.state.name}`}
    icon={<i className="fa fa-list" />}
  >
    {this.hasChecks() ? this.checksList() : this.successLog()}
  </EpubValidatorResults>)

  checksList = () => this.state.checks.map((check, index) => (<CheckLog
    color
    heading={check.category}
    title={check.title}
    notes={check.report}
    description={check.description}
    key={`check${index}`}
  />))

  successLog = () => (<Log
    color
    heading={'success'}
    title={'No Errors Found'}
    message={'The ePub ' + this.props.check + ' did not report any problems with the file.'}
  />)

  hasChecks = () => this.state.checks && this.state.checks.length > 0

  loadingWidget = () => (<EpubValidatorResults
    key="epubValLoading"
    text={this.props.check == 'accessibility checker' ? 'Checking...' : 'Validating...'}
    icon={<img src="/assets/loading.gif" />}
  />)

  initialWidget = () => (<EpubValidatorResults
    key="epubValInitial"
    text={'Upload an ePub for the ' + this.props.check + '. Files must be 100MB or less.'}
    icon={<i className="fa fa-book" />}
  />)

  errorAlert = () => (<Alert color="danger" className="uploader-alert-danger">
    <strong>Error:</strong> {this.state.errMessage}
  </Alert>)

  bodyContent = () => {
    if (this.state.error) {
      return this.errorAlert();
    } else if (this.state.loading) {
      return this.loadingWidget();
    } else if (this.state.checks && this.state.finished) {
      return this.checksReport();
    }
    return this.initialWidget();
  }

  render() {
    return (<Container className="epub-rezipper">
      <Row>
        <Col md={6}>
          <Dropzone
            style={{}}
            ref="dropzone"
            className="uploader-dropzone"
            ref="dropzone"
            onDrop={this.onDrop}
            inputProps={{ name: 'uploader-input', id: 'uploader-input' }}
            maxSize={1e+8}
            multiple={false}
          >
            <p className="uploader-text">
              <i className="fa fa-upload" />
              <br />
              Upload your ePub here.
            </p>
          </Dropzone>
        </Col>
        <Col md={6}>
          {this.bodyContent()}
        </Col>
      </Row>
    </Container>);
  }
}

